import { SingleNews } from '@toggle/toggle';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

export const useArticleDrawer = () => {
  const { params, deleteQueryParam, setQueryParams } = useQueryParams();

  const handleSelectSingleNews = (article: SingleNews) => {
    setQueryParams({
      [queryKeys.activeArticleId]: article?.id,
      [queryKeys.activeDrawer]: 'article',
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([queryKeys.activeArticleId, queryKeys.activeDrawer]);
  };

  return {
    handleSelectSingleNews,
    closeDrawer,
    singleNewsId: params.activeArticleId,
  };
};
